import z from "zod";

/**
 * PesquisaSatisfacaoSchema
 */

export const PesquisaSatisfacaoSchema = z.object({
  status: z.coerce.number().default(1),
  codigo: z.string({ required_error: "Este campo deve ser preenchido!" }).nonempty({ message: "Este campo deve ser preenchido!" }),
  descricao: z.string({ required_error: "Este campo deve ser preenchido!" }).nonempty({ message: "Este campo deve ser preenchido!" }),
});

/**
 * PesquisaSatisfacaoForm
 */

export type PesquisaSatisfacaoForm = z.infer<typeof PesquisaSatisfacaoSchema>;